import caseRoutes from './case';

export { ROUTES } from './case';
export default [...caseRoutes];
